export { widgetTemplateStore as store } from './reducers'
export WidgetTemplateDetailsContainer from './containers/Details'
